module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-banner-social-680a03e0068f569b5fe3d8a3bdf055fe.jpg";